import React, {useState} from 'react'
import { useSelector } from 'react-redux'

import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import MenuIcon from '@mui/icons-material/Menu'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import LoginIcon from '@mui/icons-material/Login'
import LogoutIcon from '@mui/icons-material/Logout'
import Collapse from '@mui/material/Collapse'
import useTheme from '@mui/material/styles/useTheme'
import CloseIcon from '@mui/icons-material/Close'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Divider from '@mui/material/Divider'

import { Link, useLocation } from 'react-router-dom'

import { PAGES, MOBILE_NAV_ROUTES, isLoggedIn, routeVisible } from './routes'
import { MobileNavStyle } from '../styles'

const MobileNav = ({logoutHandler}) => {
    const theme = useTheme()
    const small_screen = theme.breakpoints.values.sm
    const [show, setShow] = useState(false)
    const [resourcesOpen, setResourcesOpen] = useState(false)
    const location = useLocation()

    const user = useSelector(state => state.user)
    const loggedIn = isLoggedIn(user)
    const toggleShow = () => setShow(!show)

    // If mobile the drop down style changes
    const dropDownStyle = () => {
        if (window.innerWidth < small_screen) {
            return MobileNavStyle.dropDownXS
        }
        return MobileNavStyle.dropDownS
    }

    return (
        <>
            <Box sx={MobileNavStyle.navIconBox}>
                <IconButton {...MobileNavStyle.navIcon} onClick={() => toggleShow()}>
                    {show? <CloseIcon />:<MenuIcon />}
                </IconButton>
            </Box>
            <Box sx={MobileNavStyle.headerContainer}>
                <Link to={PAGES.home.path} style={MobileNavStyle.reactLink} >
                    <Icon sx={MobileNavStyle.headerIcon}>
                        <img src='/static/logo.svg' alt="ResourceHub Logo"/>
                    </Icon>
                </Link>
                <Link to={PAGES.home.path} style={MobileNavStyle.reactLink} >
                    <Typography noWrap {...MobileNavStyle.header.props} sx={MobileNavStyle.header.style} >
                        {PAGES.home.mobile_title}
                    </Typography>
                </Link>
            </Box>

            <Box sx={dropDownStyle()}>
                <Collapse in={show}>
                    <Box sx={MobileNavStyle.listContainer}>
                        <List {...MobileNavStyle.list.props} sx={MobileNavStyle.list.style} >
                            {MOBILE_NAV_ROUTES.filter(route => route.user === false).map(route => (
                                route.children?
                                    <Box key={route.title}>
                                        <Divider light />
                                        <ListItemButton onClick={() => setResourcesOpen(!resourcesOpen)} sx={MobileNavStyle.listButton}>
                                            <ListItemIcon sx={MobileNavStyle.listIcon}>
                                                <route.icon />
                                            </ListItemIcon>
                                            <ListItemText primaryTypographyProps={MobileNavStyle.listText} primary={route.title} />
                                            {resourcesOpen? <ExpandLessIcon sx={MobileNavStyle.listIcon} />:<ExpandMoreIcon sx={MobileNavStyle.listIcon} />}
                                        </ListItemButton>
                                        <Collapse in={resourcesOpen}>
                                            <List component='div' disablePadding>
                                                {route.children.map(child => (
                                                    <Link key={child.path} to={child.path} style={MobileNavStyle.reactLink} >
                                                        <ListItemButton onClick={() => toggleShow()} sx={MobileNavStyle.subListButton}>
                                                            <ListItemIcon sx={MobileNavStyle.listIcon}>
                                                                <child.icon />
                                                            </ListItemIcon>
                                                            <ListItemText primaryTypographyProps={MobileNavStyle.listText} primary={child.title} />
                                                        </ListItemButton>
                                                    </Link>
                                                ))}
                                            </List>
                                        </Collapse>
                                    </Box>
                                    :
                                    <Box key={route.path}>
                                        <Divider light />
                                        <Link to={route.path} style={MobileNavStyle.reactLink} >
                                            <ListItemButton onClick={() => toggleShow()} sx={MobileNavStyle.listButton}>
                                                <ListItemIcon sx={MobileNavStyle.listIcon}>
                                                    <route.icon />
                                                </ListItemIcon>
                                                <ListItemText primaryTypographyProps={MobileNavStyle.listText} primary={route.title} />
                                            </ListItemButton>
                                        </Link>
                                    </Box>
                            ))}
                            {MOBILE_NAV_ROUTES.filter(route => (
                                route.user && !route.staff && !route.terminology_admin && routeVisible(route, user)
                            )).map(route => (
                                <Box key={route.path}>
                                    <Divider light />
                                    <Link to={route.path} style={MobileNavStyle.reactLink} >
                                        <ListItemButton onClick={() => toggleShow()} sx={MobileNavStyle.listButton}>
                                            <ListItemIcon sx={MobileNavStyle.listIcon}>
                                                <route.icon />
                                            </ListItemIcon>
                                            <ListItemText primaryTypographyProps={MobileNavStyle.listText} primary={route.title} />
                                        </ListItemButton>
                                    </Link>
                                </Box>
                            ))}
                            {!loggedIn &&
                            <Box>
                                <Divider light/>
                                <Link to={PAGES.login.path} state={{ from: location.pathname + location.search }} style={MobileNavStyle.reactLink} >
                                    <ListItemButton onClick={() => toggleShow()} sx={MobileNavStyle.listButton}>
                                        <ListItemIcon sx={MobileNavStyle.listIcon}>
                                            <LoginIcon />
                                        </ListItemIcon>
                                        <ListItemText primaryTypographyProps={MobileNavStyle.listText} primary={PAGES.login.title} />
                                    </ListItemButton>
                                </Link>
                            </Box>
                            }
                            {MOBILE_NAV_ROUTES.filter(route => route.staff && routeVisible(route, user)).map(route => (
                                <Box key={route.path}>
                                    <Divider light />
                                    <Link to={route.path} style={MobileNavStyle.reactLink} >
                                        <ListItemButton onClick={() => toggleShow()} sx={MobileNavStyle.listButton}>
                                            <ListItemIcon sx={MobileNavStyle.listIcon}>
                                                <route.icon />
                                            </ListItemIcon>
                                            <ListItemText primaryTypographyProps={MobileNavStyle.listText} primary={route.title} />
                                        </ListItemButton>
                                    </Link>
                                </Box>
                            ))}
                            {MOBILE_NAV_ROUTES.filter(route => route.terminology_admin && routeVisible(route, user)).map(route => (
                                <Box key={route.path}>
                                    <Divider light />
                                    <Link to={route.path} style={MobileNavStyle.reactLink} >
                                        <ListItemButton onClick={() => toggleShow()} sx={MobileNavStyle.listButton}>
                                            <ListItemIcon sx={MobileNavStyle.listIcon}>
                                                <route.icon />
                                            </ListItemIcon>
                                            <ListItemText primaryTypographyProps={MobileNavStyle.listText} primary={route.title} />
                                        </ListItemButton>
                                    </Link>
                                </Box>
                            ))}
                            {loggedIn && <Box>
                                <Divider light/>
                                <ListItemButton onClick={() => logoutHandler(false)} sx={{paddingLeft: '36px'}}>
                                    <ListItemIcon sx={MobileNavStyle.listIcon}>
                                        <LogoutIcon />
                                    </ListItemIcon>
                                    <ListItemText primaryTypographyProps={MobileNavStyle.listText} primary={'Logout'} />
                                </ListItemButton>
                            </Box>}
                            <Divider light/>
                        </List>
                    </Box>
                </Collapse>
            </Box>
        </>
    )
}

export default MobileNav